import GroupedReportView from '../../../components/reports/GroupedReportView';

export function BalanceSheetReport() {
  return (
    <GroupedReportView
      title="Balance Sheet"
      description="Assets, liabilities and equity as at a given date."
      endpoint="/reports/consolidated/balance-sheet"
      filters={['asOfDate']}
      supportsComparative
      xlsx
    />
  );
}
